import router from "next/router";
import setAccessTokenCookie from "@/lib/setAccessTokenCookie";

export const useAccessTokenCookie = () => {
  return (token: string, expires_in: number) => {
    setAccessTokenCookie(token, expires_in);
    router.push("/profile");
  };
};
